import PromoButton from './promoButton';

export default PromoButton;
